<template>
  <div class="pg-404">
    <div class="error">
      <div class="title" v-if="authorityCheckResult==-1">404:网络异常，请刷新页面重试</div>
      <div class="title" v-else>404:当前页面出错，请联系管理员</div>
      <svg
        height="100%"
        node-id="1"
        sillyvg="true"
        template-height="800"
        template-width="800"
        version="1.1"
        viewBox="0 0 800 800"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <defs node-id="108">
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_1_"
            node-id="7"
            spreadMethod="pad"
            x1="404.7951"
            x2="404.7951"
            y1="516.1346"
            y2="665.7734"
          >
            <stop offset="0" stop-color="#d4dbe5"></stop>
            <stop offset="1" stop-color="#ffffff"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_2_"
            node-id="11"
            spreadMethod="pad"
            x1="396.8719"
            x2="396.8719"
            y1="445.1562"
            y2="130.8055"
          >
            <stop offset="0.1119" stop-color="#ffffff"></stop>
            <stop offset="0.9205" stop-color="#e2e6ed"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_3_"
            node-id="15"
            spreadMethod="pad"
            x1="153.1373"
            x2="153.1373"
            y1="370.1034"
            y2="339.7182"
          >
            <stop offset="0.1119" stop-color="#f1f3f6"></stop>
            <stop offset="0.9205" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_4_"
            node-id="19"
            spreadMethod="pad"
            x1="604.7491"
            x2="604.7491"
            y1="283.6037"
            y2="240.4763"
          >
            <stop offset="0.1119" stop-color="#f1f3f6"></stop>
            <stop offset="0.9205" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientTransform="matrix(0 -1 1 0 -2639.4705 -1501.9823)"
            gradientUnits="userSpaceOnUse"
            id="SVGID_5_"
            node-id="23"
            spreadMethod="pad"
            x1="-2070.8145"
            x2="-2070.8145"
            y1="3234.908"
            y2="3210.4038"
          >
            <stop offset="0.1119" stop-color="#f1f3f6"></stop>
            <stop offset="0.9205" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_6_"
            node-id="28"
            spreadMethod="pad"
            x1="166.7016"
            x2="305.6702"
            y1="447.7422"
            y2="447.7422"
          >
            <stop offset="0" stop-color="#d4dbe5"></stop>
            <stop offset="1" stop-color="#ffffff"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_7_"
            node-id="32"
            spreadMethod="pad"
            x1="170.1542"
            x2="216.1483"
            y1="414.4974"
            y2="414.4974"
          >
            <stop offset="0.1119" stop-color="#b2c5d6"></stop>
            <stop offset="0.9205" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_8_"
            node-id="36"
            spreadMethod="pad"
            x1="263.622"
            x2="285.1599"
            y1="531.8281"
            y2="531.8281"
          >
            <stop offset="0.1119" stop-color="#c9d5e2"></stop>
            <stop offset="0.9205" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_9_"
            node-id="40"
            spreadMethod="pad"
            x1="204.434"
            x2="204.434"
            y1="561.8264"
            y2="327.5543"
          >
            <stop offset="0.327" stop-color="#e4e8ef"></stop>
            <stop offset="1" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_10_"
            node-id="44"
            spreadMethod="pad"
            x1="287.7905"
            x2="305.7935"
            y1="468.9098"
            y2="468.9098"
          >
            <stop offset="0.1119" stop-color="#c9d5e2"></stop>
            <stop offset="0.9205" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_11_"
            node-id="48"
            spreadMethod="pad"
            x1="194.8159"
            x2="284.1837"
            y1="322.3315"
            y2="322.3315"
          >
            <stop offset="0" stop-color="#d4dbe5"></stop>
            <stop offset="1" stop-color="#ffffff"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_12_"
            node-id="52"
            spreadMethod="pad"
            x1="261.8957"
            x2="284.1735"
            y1="389.7802"
            y2="389.7802"
          >
            <stop offset="0.1119" stop-color="#c9d5e2"></stop>
            <stop offset="0.9205" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_13_"
            node-id="56"
            spreadMethod="pad"
            x1="320.2618"
            x2="472.9998"
            y1="422.8517"
            y2="422.8517"
          >
            <stop offset="0" stop-color="#d4dbe5"></stop>
            <stop offset="1" stop-color="#ffffff"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_14_"
            node-id="60"
            spreadMethod="pad"
            x1="395.6854"
            x2="395.6854"
            y1="567.1724"
            y2="324.3298"
          >
            <stop offset="0.327" stop-color="#e4e8ef"></stop>
            <stop offset="1" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_15_"
            node-id="64"
            spreadMethod="pad"
            x1="365.6393"
            x2="424.8273"
            y1="453.6445"
            y2="453.6445"
          >
            <stop offset="0" stop-color="#d4dbe5"></stop>
            <stop offset="1" stop-color="#ffffff"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_16_"
            node-id="68"
            spreadMethod="pad"
            x1="556.7263"
            x2="648.5089"
            y1="323.7559"
            y2="323.7559"
          >
            <stop offset="0" stop-color="#d4dbe5"></stop>
            <stop offset="1" stop-color="#ffffff"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_17_"
            node-id="72"
            spreadMethod="pad"
            x1="548.8962"
            x2="669.6908"
            y1="453.5535"
            y2="453.5535"
          >
            <stop offset="0" stop-color="#d4dbe5"></stop>
            <stop offset="1" stop-color="#ffffff"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_18_"
            node-id="76"
            spreadMethod="pad"
            x1="545.9985"
            x2="602.7204"
            y1="419.2157"
            y2="419.2157"
          >
            <stop offset="0.1119" stop-color="#c9d5e2"></stop>
            <stop offset="0.9205" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_19_"
            node-id="80"
            spreadMethod="pad"
            x1="488.1668"
            x2="581.1826"
            y1="391.9339"
            y2="391.9339"
          >
            <stop offset="0.3211" stop-color="#e6eaf0"></stop>
            <stop offset="1" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_20_"
            node-id="84"
            spreadMethod="pad"
            x1="488.082"
            x2="501.8609"
            y1="470.7357"
            y2="470.7357"
          >
            <stop offset="0.1119" stop-color="#c9d5e2"></stop>
            <stop offset="0.9205" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_21_"
            node-id="88"
            spreadMethod="pad"
            x1="568.6873"
            x2="595.3287"
            y1="532.0554"
            y2="532.0554"
          >
            <stop offset="0.1119" stop-color="#c9d5e2"></stop>
            <stop offset="0.9205" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_22_"
            node-id="92"
            spreadMethod="pad"
            x1="585.7758"
            x2="585.7758"
            y1="563.5579"
            y2="329.2858"
          >
            <stop offset="0.327" stop-color="#e4e8ef"></stop>
            <stop offset="1" stop-color="#d2d9e3"></stop>
          </linearGradient>
        </defs>
        <g node-id="295">
          <g node-id="296">
            <path
              d="M 699.34 590.95 C 699.34 632.27 567.47 665.77 404.80 665.77 C 242.13 665.77 110.26 632.27 110.26 590.95 C 110.26 549.63 242.13 516.13 404.80 516.13 C 567.47 516.13 699.34 549.63 699.34 590.95 Z"
              fill="url(#SVGID_1_)"
              fill-rule="nonzero"
              group-id="1,2"
              node-id="248"
              stroke="none"
              target-height="149.64001"
              target-width="589.08"
              target-x="110.26"
              target-y="516.13"
            ></path>
            <path
              d="M 574.09 267.29 L 574.09 148.02 L 550.16 130.81 L 445.59 172.38 L 445.59 294.17 L 421.65 294.17 L 421.65 260.57 L 375.87 260.57 L 375.87 292.07 L 354.04 292.07 L 354.04 233.28 L 314.56 233.28 L 314.56 337.43 L 303.64 337.43 L 303.64 153.90 L 210.41 153.90 L 210.41 322.31 L 162.95 322.31 L 162.95 384.68 L 135.66 384.68 L 135.66 445.16 L 658.09 445.16 L 658.09 440.32 L 658.09 384.68 L 658.09 267.29 Z"
              fill="url(#SVGID_2_)"
              fill-rule="nonzero"
              group-id="1,2"
              node-id="250"
              stroke="none"
              target-height="314.35"
              target-width="522.43005"
              target-x="135.66"
              target-y="130.81"
            ></path>
            <path
              d="M 168.33 354.91 C 168.33 363.30 161.53 370.10 153.14 370.10 C 144.75 370.10 137.95 363.30 137.95 354.91 C 137.95 346.52 144.75 339.72 153.14 339.72 C 161.53 339.72 168.33 346.52 168.33 354.91 Z"
              fill="url(#SVGID_3_)"
              fill-rule="nonzero"
              group-id="1,2"
              node-id="252"
              stroke="none"
              target-height="30.380005"
              target-width="30.380005"
              target-x="137.95"
              target-y="339.72"
            ></path>
            <path
              d="M 626.31 262.04 C 626.31 273.95 616.66 283.60 604.75 283.60 C 592.84 283.60 583.19 273.95 583.19 262.04 C 583.19 250.13 592.84 240.48 604.75 240.48 C 616.66 240.48 626.31 250.13 626.31 262.04 Z"
              fill="url(#SVGID_4_)"
              fill-rule="nonzero"
              group-id="1,2"
              node-id="254"
              stroke="none"
              target-height="43.12001"
              target-width="43.119995"
              target-x="583.19"
              target-y="240.48"
            ></path>
            <path
              d="M 595.44 568.83 C 595.44 575.60 589.96 581.08 583.19 581.08 C 576.42 581.08 570.94 575.60 570.94 568.83 C 570.94 562.06 576.42 556.58 583.19 556.58 C 589.96 556.58 595.44 562.06 595.44 568.83 Z"
              fill="url(#SVGID_5_)"
              fill-rule="nonzero"
              group-id="1,2"
              node-id="256"
              stroke="none"
              target-height="24.5"
              target-width="24.5"
              target-x="570.94"
              target-y="556.58"
            ></path>
          </g>
          <g node-id="297">
            <path
              d="M 194.82 432.87 L 305.67 432.87 L 287.79 462.61 L 166.70 462.61 Z"
              fill="url(#SVGID_6_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="261"
              stroke="none"
              target-height="29.73999"
              target-width="138.97002"
              target-x="166.7"
              target-y="432.87"
            ></path>
            <path
              d="M 216.15 412.03 L 204.80 432.94 L 214.30 432.94 L 214.30 448.78 L 170.15 462.09 L 172.81 452.68 L 215.90 366.90 Z"
              fill="url(#SVGID_7_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="263"
              stroke="none"
              target-height="95.19"
              target-width="46"
              target-x="170.15"
              target-y="366.9"
            ></path>
            <path
              d="M 285.16 501.83 L 285.16 533.91 L 263.62 561.83 L 263.62 504.95 Z"
              fill="url(#SVGID_8_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="265"
              stroke="none"
              target-height="60.00003"
              target-width="21.540009"
              target-x="263.62"
              target-y="501.83"
            ></path>
            <path
              d="M 262.14 462.61 L 262.14 327.55 L 194.81 327.55 L 121.07 463.78 L 121.07 503.73 L 214.54 503.73 L 214.54 561.82 L 263.62 561.82 L 263.62 504.94 L 287.79 504.94 L 287.79 462.60 L 262.14 462.60 Z M 214.05 462.09 L 170.15 462.09 L 214.05 374.82 L 214.05 462.09 Z"
              fill="url(#SVGID_9_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="267"
              stroke="none"
              target-height="234.27002"
              target-width="166.72"
              target-x="121.07"
              target-y="327.55"
            ></path>
            <path
              d="M 287.79 504.95 C 288.04 504.43 305.79 468.85 305.79 468.85 L 305.67 432.88 L 287.79 462.62 L 287.79 504.95 Z"
              fill="url(#SVGID_10_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="269"
              stroke="none"
              target-height="72.07001"
              target-width="18"
              target-x="287.79"
              target-y="432.88"
            ></path>
            <path
              d="M 194.82 327.55 L 226.26 317.43 L 284.18 317.11 L 262.14 327.55 Z"
              fill="url(#SVGID_11_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="271"
              stroke="none"
              target-height="10.440002"
              target-width="89.359985"
              target-x="194.82"
              target-y="317.11"
            ></path>
            <path
              d="M 261.90 462.52 L 284.17 432.83 L 284.17 317.04 L 262.14 327.55 Z"
              fill="url(#SVGID_12_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="273"
              stroke="none"
              target-height="145.47998"
              target-width="22.27002"
              target-x="261.9"
              target-y="317.04"
            ></path>
            <path
              d="M 396.63 314.11 C 347.28 314.11 320.26 362.79 320.26 422.85 C 320.26 482.90 354.45 531.59 396.63 531.59 C 438.81 531.59 473.00 482.91 473.00 422.85 C 473.00 362.80 451.10 316.19 396.63 314.11 Z M 395.56 525.36 C 374.19 525.36 365.64 490.65 365.64 447.10 C 365.64 403.54 372.22 367.62 395.56 367.62 C 418.58 367.62 424.83 403.02 424.83 446.58 C 424.83 490.14 416.11 525.36 395.56 525.36 Z"
              fill="url(#SVGID_13_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="275"
              stroke="none"
              target-height="217.48004"
              target-width="152.73999"
              target-x="320.26"
              target-y="314.11"
            ></path>
            <path
              d="M 395.69 324.33 C 351.90 324.33 316.40 357.06 316.40 445.75 C 316.40 531.76 351.90 567.17 395.69 567.17 C 439.48 567.17 474.98 528.64 474.98 445.75 C 474.97 361.21 439.47 324.33 395.69 324.33 Z M 395.56 525.36 C 374.19 525.36 365.64 490.65 365.64 447.10 C 365.64 403.54 372.22 367.62 395.56 367.62 C 418.58 367.62 424.83 403.02 424.83 446.58 C 424.83 490.14 416.11 525.36 395.56 525.36 Z"
              fill="url(#SVGID_14_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="277"
              stroke="none"
              target-height="242.84"
              target-width="158.58002"
              target-x="316.4"
              target-y="324.33"
            ></path>
            <path
              d="M 423.38 414.85 C 421.67 482.82 406.90 486.23 397.20 486.23 C 387.17 486.23 374.84 475.32 373.85 440.52 C 372.04 412.58 373.67 393.48 375.50 381.94 C 368.13 396.37 365.63 420.28 365.63 447.10 C 365.63 490.66 374.18 525.36 395.55 525.36 C 416.10 525.36 424.82 490.14 424.82 446.58 C 424.83 435.29 424.40 424.56 423.38 414.85 Z"
              fill="url(#SVGID_15_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="279"
              stroke="none"
              target-height="143.41998"
              target-width="59.19998"
              target-x="365.63"
              target-y="381.94"
            ></path>
            <path
              d="M 556.73 318.36 L 615.36 318.23 L 648.51 329.29 L 581.18 329.29 Z"
              fill="url(#SVGID_16_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="281"
              stroke="none"
              target-height="11.059998"
              target-width="91.78003"
              target-x="556.73"
              target-y="318.23"
            ></path>
            <path
              d="M 646.99 443.93 L 669.69 464.34 L 548.90 463.93 L 560.49 442.76 Z"
              fill="url(#SVGID_17_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="283"
              stroke="none"
              target-height="21.579987"
              target-width="120.78998"
              target-x="548.9"
              target-y="442.76"
            ></path>
            <path
              d="M 599.76 372.98 L 546.00 465.97 L 548.90 463.93 L 574.61 448.39 L 596.64 464.93 L 602.72 372.47 Z"
              fill="url(#SVGID_18_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="285"
              stroke="none"
              target-height="93.5"
              target-width="56.71997"
              target-x="546"
              target-y="372.47"
            ></path>
            <path
              d="M 501.86 465.51 L 488.17 436.01 L 556.73 318.36 L 581.18 329.29 Z"
              fill="url(#SVGID_19_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="287"
              stroke="none"
              target-height="147.15002"
              target-width="93.00998"
              target-x="488.17"
              target-y="318.36"
            ></path>
            <path
              d="M 501.86 505.47 L 488.29 470.30 C 488.29 470.30 487.92 435.50 488.17 436.02 C 488.42 436.54 501.86 465.52 501.86 465.52 L 501.86 505.47 Z"
              fill="url(#SVGID_20_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="289"
              stroke="none"
              target-height="69.97"
              target-width="13.939972"
              target-x="487.92"
              target-y="435.5"
            ></path>
            <path
              d="M 568.69 501.20 L 568.69 536.53 L 595.33 563.56 L 595.33 505.47 L 595.20 500.55 Z"
              fill="url(#SVGID_21_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="291"
              stroke="none"
              target-height="63.01001"
              target-width="26.640015"
              target-x="568.69"
              target-y="500.55"
            ></path>
            <path
              d="M 642.93 464.34 L 648.51 329.28 L 581.18 329.28 L 501.86 465.51 L 501.86 505.46 L 595.33 505.46 L 595.33 563.55 L 644.41 563.55 L 644.41 506.67 L 669.70 506.67 L 669.70 464.33 L 642.93 464.33 Z M 594.84 463.82 L 550.94 463.82 L 600.42 376.55 L 594.84 463.82 Z"
              fill="url(#SVGID_22_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="293"
              stroke="none"
              target-height="234.26999"
              target-width="167.84003"
              target-x="501.86"
              target-y="329.28"
            ></path>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  data() {
    return {
      authorityCheckResult: 1 // -1:网络异常  0:验证不通过（没有收费权限）  1:验证通过（收费权限和页面权限）  2:没有页面权限
    }
  },
  mounted () {
    this.authorityCheckResult = this.$route.params.authorityCheckResult
    let that =this
    setTimeout(function(){      
      throw new Error('页面404当前路由:'+that.$route.fullPath)
    },10)
  }
}
</script>

<style scoped>
.pg-404 {
  height: auto;
  margin: 0 auto;
  height: auto;
  width: 50%;
  margin: 0 25%;
}
.error {
  flex-wrap: nowrap;
  font-size: 20px;
  text-align: center;
}
.title {
  padding-top: 20px;
  color: #999;
  font-weight: 400;
}
</style>
